import { Storage } from "utils/clientStorage";
import makeStore from "utils/makeStore";

const balance = (window !== undefined ? Storage.getItem("SHOW_BALANCE")  : true);

const initialState = {
    showBalance: balance
}

export const SHOW_BALANCE = "SHOW_BALANCE";
export const HIDE_BALANCE = "HIDE_BALANCE";


const BalanceReducer = (state=initialState,action) => {
    const newState = JSON.parse(JSON.stringify(state))
    switch(action.type){
        case SHOW_BALANCE: 
            newState.showBalance = true;
            Storage.setItem("SHOW_BALANCE", true);
            break;
        case HIDE_BALANCE:
            newState.showBalance = false;
            Storage.setItem("SHOW_BALANCE", false);
            break;
       
        default: return state
    }
    return newState;
} 

const [BalanceProvider, useBalanceStore,useBalanceDispatch] = makeStore(BalanceReducer,initialState);

export {BalanceProvider,useBalanceStore,useBalanceDispatch};